import { PlatformThemeId } from '@reward-platform/shared-schemas'

// Logo
import EILogo from '~/public/assets/aer-lingus-logo.svg'
import EILogoMobile from '~/public/assets/aer-lingus-logo-mobile.svg'
import BALogo from '~/public/assets/british-airways-logo.svg'
import BALogoMobile from '~/public/assets/british-airways-logo-mobile.svg'
import AviosLogo from '~/public/assets/avios-logo.svg'

// Favicon
import EIFavicon from '~/public/assets/favicon/AER_LINGUS.ico'
import BAFavicon from '~/public/assets/favicon/BRITISH_AIRWAYS.ico'
import AviosFavicon from '~/public/assets/favicon/AVIOS.ico'
import VUFavicon from '~/public/assets/favicon/VUELING.ico'

import { getPublicAssetSrc } from './publicAssets'

type ThemeAssets = {
  logo?: string
  favicon?: string
}

/* istanbul ignore next */
export function getThemeAssets(
  theme: PlatformThemeId,
  shouldUseMobileLogo?: boolean
): ThemeAssets | null {
  const assets: ThemeAssets = {}

  switch (theme) {
    case 'aer_lingus': {
      assets.logo = shouldUseMobileLogo ? EILogoMobile.src : EILogo.src
      assets.favicon = EIFavicon.src
      break
    }
    case 'british_airways': {
      assets.logo = shouldUseMobileLogo ? BALogoMobile.src : BALogo.src
      assets.favicon = BAFavicon.src
      break
    }
    case 'avios': {
      assets.logo = AviosLogo.src
      assets.favicon = AviosFavicon.src
      break
    }
    default:
      return null
  }
  return assets
}

export const getLogoUrlForTheme = (theme: PlatformThemeId, shouldUseMobileLogo?: boolean) => {
  const assets = getThemeAssets(theme, shouldUseMobileLogo)
  return assets?.logo ?? ''
}

export const getFaviconUrlForTheme = (theme: PlatformThemeId) => {
  const assets = getThemeAssets(theme)
  return assets?.favicon ?? ''
}

export const getFallbackImageUrlForTheme = (theme: PlatformThemeId) =>
  getPublicAssetSrc(`/assets/default-brand-images/${theme.toLowerCase()}.svg`)

export const getStylesheetForTheme = (theme: PlatformThemeId) =>
  getPublicAssetSrc(`/assets/themes/${theme}.css`)
